var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGForcedMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 30C7.975 26.575 4.969 23.394 2.982 20.457C0.995 17.52 0.001 14.801 0 12.3C0 8.55 1.2065 5.5625 3.6195 3.3375C6.0325 1.1125 8.826 0 12 0C15.174 0 17.968 1.1125 20.382 3.3375C22.796 5.5625 24.002 8.55 24 12.3C24 14.8 23.0065 17.519 21.0195 20.457C19.0325 23.395 16.026 26.576 12 30ZM8.47597 16.876L7.59486 18.5683L4.9515 16.876L2.30814 15.1837L6.71374 13.4913L4.07038 7.56827L9.35709 10.1067L12.0005 3.3375L14.6438 10.1067L19.9305 7.56827L17.2872 13.4913L21.6928 15.1837L16.406 18.5683L15.5249 16.876L18.1683 15.1837L15.5249 14.3375L17.2872 10.1067L13.7627 11.799L12.0005 6.72212L10.2382 11.799L6.71374 10.1067L8.47597 14.3375L5.83262 15.1837L8.47597 16.876ZM14.6438 17.7221L13.3851 18.4611H10.6158L9.35709 17.7221L10.2382 16.876L8.47597 15.1837H10.2382L9.35709 12.6452L11.1193 14.3375L12.0005 10.9529L12.8816 14.3375L14.6438 12.6452L13.7627 15.1837H15.5249L13.7627 16.876L14.6438 17.7221Z",
    fill: "#B11500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGForcedMarker);
export default __webpack_public_path__ + "static/media/gForced-marker.779680227781c637c03c19f292843f6f.svg";
export { ForwardRef as ReactComponent };